export const CORRECT_GUESS_BONUS = 10;
